module.exports = __webpack_public_path__ + "media/images/logo/niet_gebruikt/logo8-829f0c1a268444fffda1390a5f1c560c.png";